import { Trans } from 'react-i18next'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'
import { VariableSelectFeatureFlag } from '@makyoapp/makyo-common'

import { useCreateColumnContext } from '@/context/CreateColumnContext'
import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'
import { VariableSelectV2 } from '@/components/VariableSelectV2/VariableSelectV2'

import { Fld, Lbl } from './shared'

/**
 * handle all fields for Join column type
 *
 * @todo
 */
export default function FieldJoin() {
  const { id, value, setValue } = useCreateColumnContext()

  const { table, gridModal } = useGridV2Context()
  const columnToEdit = gridModal?.column?.id

  return (
    <>
      <Fld>
        <Lbl>
          <Trans>Join</Trans>
        </Lbl>
        <VariableSelectV2
          id={`${id}-join-value`}
          multiple
          value={value.joinOptions.joinValue}
          variableColumnOptions={{
            columnTypes: [
              ColumnTypes.Text,
              ColumnTypes.Number,
              ColumnTypes.DateTime,
              ColumnTypes.Boolean,
              ColumnTypes.URL,
              ColumnTypes.Image,
              ColumnTypes.Phone,
              ColumnTypes.Attachment,
              ColumnTypes.Rating,
              ColumnTypes.Icon,
              ColumnTypes.Address,
              ColumnTypes.Color,
              ColumnTypes.RichText,
              ColumnTypes.Join,
              ColumnTypes.Email,
              ColumnTypes.Lookup,
              ColumnTypes.Function,
            ],
            excludeColIds: columnToEdit ? [columnToEdit] : [],
          }}
          featureFlags={
            VariableSelectFeatureFlag.Column |
            VariableSelectFeatureFlag.SingleCell |
            VariableSelectFeatureFlag.ProfileData |
            VariableSelectFeatureFlag.DateTime |
            VariableSelectFeatureFlag.CustomText |
            VariableSelectFeatureFlag.Space
          }
          tableId={table?.id || ''}
          onChange={(v) => {
            setValue({
              joinOptions: {
                ...value.joinOptions,
                joinValue: Array.isArray(v) ? v : [],
              },
            })
          }}
        />
        {/*
           <VariableText
           value={value.joinOptions.joinValue}
           tableId={table?.id}
           featureFlags={
           VariableTextFeatureFlag.Column |
           VariableTextFeatureFlag.SingleCell |
           VariableTextFeatureFlag.ProfileData |
           VariableTextFeatureFlag.DateTime
           }
           variableColumnOptions={{
           columnTypes: [
           ColumnTypes.Text,
           ColumnTypes.Number,
           ColumnTypes.DateTime,
           ColumnTypes.Boolean,
           ColumnTypes.URL,
           ColumnTypes.Image,
           ColumnTypes.Phone,
           ColumnTypes.Attachment,
           ColumnTypes.Rating,
           ColumnTypes.Icon,
           ColumnTypes.Address,
           ColumnTypes.Color
           ]
           }}
           id={`${id}-join-value`}
           onChange={(v) => {
           setValue({
           joinOptions: {
           ...value.joinOptions,
           joinValue: v
           }
           })
           }}
           />
           */}
      </Fld>
    </>
  )
}
